import useViewsSelector from "views/stores/useViewsSelector";
import { selectSearchExecutionState } from "views/logic/slices/searchExecutionSelectors";
const useSearchExecutionState = () => useViewsSelector(selectSearchExecutionState);
export default useSearchExecutionState;
